import {
  faHeart,
  faHouse,
  faLocationDot,
  faPaperPlane,
  faQuestionCircle,
  faShareAlt,
} from "@fortawesome/pro-regular-svg-icons"
import { LinkItem } from "component/w24/component/LinkItem"
import { MenuItem } from "component/w24/component/MenuItem"
import { PCScreen } from "component/w24/layout/PCScreen"
import { motion } from "framer-motion"
import { SVG_Logo } from "libs/images/w24/SVG_Logo"
import { Localization } from "libs/localization/localization"
import { AnimTap } from "libs/style/w24_styling"
import React, { useEffect } from "react"
import { Link as Link2, scrollSpy } from "react-scroll"
import styled from "styled-components/macro"

interface Props {
  selectedItem?: string
  className?: string
}

export const HeaderMenu = (props: Props): JSX.Element => {
  useEffect(() => {
    scrollSpy.update()
  }, [])

  return (
    <S_HeaderMenu className={props.className}>
      <S_PCScreen>
        <S_Left>
          <Link2
            to="about"
            spy={true}
            smooth={true}
            offset={-50}
            duration={500}
          >
            <S_Logo {...AnimTap}>
              <S_SVG_Logo />
            </S_Logo>
          </Link2>
          <Link2
            to="about"
            spy={true}
            smooth={true}
            offset={-50}
            duration={500}
          >
            <MenuItem
              title={Localization.ABOUT}
              icon={faHouse}
              selected={props.selectedItem === "about"}
            />
          </Link2>
          <Link2 to="map" spy={true} smooth={true} offset={-50} duration={500}>
            <MenuItem
              title={Localization.MAP}
              icon={faLocationDot}
              selected={props.selectedItem === "map"}
            />
          </Link2>
          <Link2 to="faq" spy={true} smooth={true} offset={-50} duration={500}>
            <MenuItem
              title={Localization.FAQ}
              icon={faQuestionCircle}
              selected={props.selectedItem === "faq"}
            />
          </Link2>
          <Link2
            to={"contact"}
            spy={true}
            smooth={true}
            offset={-50}
            duration={500}
          >
            <MenuItem
              title={Localization.CONTACT}
              icon={faPaperPlane}
              selected={props.selectedItem === "contact"}
            />
          </Link2>
          <Link2
            to="partners"
            spy={true}
            smooth={true}
            offset={-50}
            duration={500}
          >
            <MenuItem
              title={Localization.PARTNERS}
              icon={faShareAlt}
              selected={props.selectedItem === "partners"}
            />
          </Link2>
          <Link2
            to="trondheim"
            spy={true}
            smooth={true}
            offset={-50}
            duration={500}
          >
            <MenuItem
              title="Trondheim"
              icon={faHeart}
              selected={props.selectedItem === "trondheim"}
            />
          </Link2>
        </S_Left>

        <S_Right>
          <LinkItem
            title={Localization.ADMIN_CALL}
            link="https://app.mapheim.com/login"
          />
        </S_Right>
      </S_PCScreen>
    </S_HeaderMenu>
  )
}

const S_HeaderMenu = styled.div`
  display: flex;
  width: 100%;
  height: 80px;
  background: #fff;
  box-shadow: 9.002px 9.002px 45.012px 0px rgba(0, 0, 0, 0.1);
  align-items: center;
`

const S_Logo = styled(motion.div)`
  display: flex;
  cursor: pointer;
`

const S_SVG_Logo = styled(SVG_Logo)`
  margin: 0 35px 0 0;
`

const S_PCScreen = styled(PCScreen)`
  display: flex;
  justify-content: space-between;
`

const S_Left = styled.div`
  display: flex;
  align-items: center;
  gap: 15px;
`

const S_Right = styled.div`
  display: flex;
`
